import React, { FC, useEffect, useState } from 'react';
import SearchBar from '../SearchBar';
import { Dropdown } from 'react-bootstrap';
import { SearchTypeEnum } from '../../types/SearchTypeEnum';
import { useStoreContext } from '../App/StoreProvider';
import * as MessageListActions from '../../store/actions/messageList';
import { EXPORT_DRIVER_MESSAGES_BY_DRIVER_ID } from '../../graphql/client/queries';
import { ExportDriverMessagesByDriverId } from '../../types/schemaTypes';
import { useLazyQuery } from '@apollo/client/react';
import DatePickerFilterItem from '../Filter/DatePickerFilterItem/DatePickerFilterItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Routes } from '../../utils';
import { Modal, Button } from 'react-bootstrap';
import useRefresh from '../../utils/useRefresh';
import moment from 'moment';
import * as LoadManagementListActions from '../../store/actions/loadManagementList';
import { useLocation, matchPath } from "react-router";
import { useParams } from 'react-router-dom';

interface LooseObject {
    [key: string]: any;
}

interface MessageHeaderProps {
    match: any;
    history: any;
    abortRequest: () => void;
    markAllAsReadHander: () => void;
    showFilterHandler: () => void;
    isFetching: boolean;
}

const MessageHeader: FC<MessageHeaderProps> = (props: MessageHeaderProps): React.ReactElement => {
    const [state, dispatch] = useStoreContext();
    const {
        messageList: { filters, searchPhrase, dateFilter },
    } = state;
    const { regionIds, messageType, carrierIds } = filters;
    const [selectDateRangeFilter, setSelectDateRangeFilter] = useState<boolean>(false);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [exportDriverMessagesByDriverId, { data: exportData, loading: exportLoading }] = useLazyQuery<ExportDriverMessagesByDriverId>(
        EXPORT_DRIVER_MESSAGES_BY_DRIVER_ID,
    );

    const handleSelect = e => {
        if (e !== 'DATERANGE') {
            dispatch(MessageListActions.setDateFilter(e));
        } else {
            setSelectDateRangeFilter(true);
        }
    };

    const refresh = useRefresh(props.history, `${Routes.MESSAGES.route}`);

    useEffect(() => {
        if (exportData && exportData.exportDriverMessagesByDriverId && !exportLoading) {
            if (
                exportData &&
                exportData.exportDriverMessagesByDriverId &&
                exportData.exportDriverMessagesByDriverId.csvDownloadUrl
            ) {
                window.open(exportData.exportDriverMessagesByDriverId.csvDownloadUrl, '_blank');
            }
        }
    }, [exportData, exportLoading]);

    let driverId = 0;
    let conversationid;
    let isDriver = false;
    let isAllconverationExport = false;

    let title = 'All Conversations';
    let driverCellNo = null;
    let groupDrivers = [];

    let isGroupAl = false;
    const { pathname } = useLocation(); 
    
   //const isAdminPath = matchPath("/admin/*", pathname);
    switch (pathname) {
        case '/messages/':
            title = 'All Conversations';
            isAllconverationExport = true;
            break;
        case '/messages/:messageId':
            // driverId = parseInt(props.match.params.messageId);
            const {messageId} = useParams();
            const conversationId:any = messageId
            let isConversation = false;
            // logic to get conversationId
            if (isNaN(Number(conversationId))) {
                isConversation = true;
            }

            isDriver = !isConversation;
            driverId = isConversation ? 0 : parseInt(conversationId);
            const driverDataSring1 = localStorage.getItem('driverData_' +conversationId);
            if (driverDataSring1) {
                const driverData = JSON.parse(driverDataSring1);
                title = driverData.name;
                driverCellNo = driverData.cellPhone;
                isGroupAl = driverData.isGroupAl;
                groupDrivers = isConversation ? driverData.driver.groupConversationDrivers : [];
            }
            break;
        // case '/messages/:messageId/:conversationId':
        //     conversationid = props.match.params.conversationId;
        //     let driverDataSring = localStorage.getItem('driverData');
        //     if (driverDataSring) {
        //         let driverData = JSON.parse(driverDataSring);
        //         title = driverData.name;
        //         driverCellNo = driverData.cellPhone;
        //         isGroupAl = driverData.isGroupAl;
        //     }
        //     break;
        default:
    }

    const exportMessageVariables = {
        driverId,
        conversationid,
        isDriver,
        dateTo: filters.toDate,
        dateFrom: filters.fromDate,
        filter: dateFilter,
        isAllconverationExport,
    };

    const exportHandler = () => {
        exportDriverMessagesByDriverId({
            variables: {
                input: exportMessageVariables,
            },
        });
    };

    const closeDateRange = (): void => {
        setSelectDateRangeFilter(false);
    };

    const messageListRefreshHandler = (event: any) => {
        if (props.isFetching) return;
        dispatch(MessageListActions.setSearchPhrase(''));
        dispatch(MessageListActions.setDateFilter('TWODAYS'));
        dispatch(MessageListActions.setDriverSearchPhrase(''));
        dispatch(MessageListActions.setFilterSearchPhrase([], 'REGION', ''));
        dispatch(MessageListActions.setFilterSearchPhrase([], 'CARRIER', ''));
        // dispatch(MessageListActions.resetFilterState());
        // props.history.push(`${Routes.HOME.route}`);
        // props.history.push(`${Routes.MESSAGES.route}`);
        refresh();
    };

    const dateFIlterMap = {
        TWODAYS: 'Last 2 days',
        ONEWEEK: 'Last 7 days',
        DATERANGE: 'Date Range',
    };

    const driverList =
        groupDrivers &&
        groupDrivers.length &&
        groupDrivers.map((groupDriver: LooseObject, index) => <span key={index}>{`${groupDriver.name}, `}</span>);

        
    return (
        <div className="Messages-Header">
            <div className="Row All-Conversations-Wrapper">
                <div
                    className="Filter-HeaderIconContainer"
                    onClick={props.showFilterHandler}
                    style={{ position: 'relative' }}
                >
                    <i className="material-icons Messages-Filter-Icon">filter_list</i>
                    {((regionIds && regionIds.length > 0) ||
                        (messageType && messageType.length > 0) ||
                        (carrierIds && carrierIds.length > 0)) && (
                        <FontAwesomeIcon
                            icon={['fas', 'check-circle']}
                            color="#fb6e3a"
                            size="sm"
                            style={{ position: 'absolute', top: '-4px', right: '-4px' }}
                        />
                    )}
                </div>
                <div className="title">All Conversations</div>
                <div
                    className={`refresh ml-auto text-center ${props.isFetching ? 'refresh-disabled' : ''}`}
                    onClick={messageListRefreshHandler}
                >
                    <FontAwesomeIcon icon={['fas', 'sync-alt']} color="#009dc7" size="lg" />
                </div>
            </div>
            <div className="Row Search-Filter-Wrapper">
                <div className="Header-SearchBar">
                    <SearchBar type={SearchTypeEnum.MessagePreview}></SearchBar>
                </div>
                <div className="my-auto pr-0">
                    <Dropdown onSelect={handleSelect}>
                        <Dropdown.Toggle variant="outline-dark" id="dropdown-basic">
                            <span>
                                {selectDateRangeFilter
                                    ? 'Date Range'
                                    : dateFilter == 'DATERANGE'
                                    ? ''
                                    : dateFIlterMap[dateFilter]}
                                {filters.fromDate &&
                                    filters.toDate &&
                                    `${moment
                                        .utc(filters.fromDate)
                                        .local()
                                        .format('MM/DD/YY')} - ${moment
                                        .utc(filters.toDate)
                                        .local()
                                        .format('MM/DD/YY')}`}
                            </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item eventKey="TWODAYS">Last 2 days</Dropdown.Item>
                            <Dropdown.Item eventKey="ONEWEEK">Last 7 days</Dropdown.Item>
                            <Dropdown.Item eventKey="DATERANGE">Date Range</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <DatePickerFilterItem
                        abortRequest={props.abortRequest}
                        title="Date Range"
                        activeKey={selectDateRangeFilter ? '0' : '1'}
                        fromDate={filters.fromDate}
                        toDate={filters.toDate}
                        filterType="Messages"
                        closeDateRange={closeDateRange}
                    />
                </div>
            </div>
        </div>
    );
};

export default MessageHeader;
